import React from 'react';
import classNames from 'classnames';
import { IconHeadphones } from '@tabler/icons-react';
import s from './custom-video-player.module.scss';
import { PlayerIconButton } from './icon-button';

/** Кнопка аудиодорожек + выпадающее меню выбора дорожки */
export const AudioTracksMenu = ({ tracks, selected, show, onToggle, onSelect, buttonClassName }) => (
	<div className={s.menuWrapper}>
		<PlayerIconButton className={buttonClassName} onClick={onToggle} ariaLabel="Аудиодорожки">
			<IconHeadphones size={20} />
		</PlayerIconButton>
		{show && (
			<div className={classNames(s.menu, s.audioMenu)}>
				{tracks.map((track) => (
					<button
						key={track.value}
						className={classNames(s.menuItem, selected === track.value && s.menuItemActive)}
						onClick={() => onSelect(track.value)}
					>
						{track.label}
					</button>
				))}
			</div>
		)}
	</div>
);
